import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';
import type {
  Address,
  AddressBody,
  AddressList,
  RegionList,
  Subdistrict,
} from '../types/address.types';

export const fetchAddresses = async (): Promise<AddressList> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.addresses}`);
};

/** The first saved address becomes the main one. */
export const createAddress = async (body: AddressBody): Promise<Address> => {
  return await request.post(`${URLS.BACK_DSH}${APIS.addresses}`, body);
};

export const updateAddress = async (addressId: string, body: AddressBody): Promise<Address> => {
  return await request.put(`${URLS.BACK_DSH}${APIS.address(addressId)}`, body);
};

/** Deleting the main address makes the oldest remaining one the main address. */
export const deleteAddress = async (addressId: string): Promise<void> => {
  await request.delete(`${URLS.BACK_DSH}${APIS.address(addressId)}`);
};

export const setDefaultAddress = async (addressId: string): Promise<AddressList> => {
  return await request.put(`${URLS.BACK_DSH}${APIS.defaultAddress(addressId)}`);
};

export const fetchProvinces = async (): Promise<RegionList> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.provinces}`);
};

export const fetchCities = async (provinceId: string): Promise<RegionList> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.cities(provinceId)}`);
};

export const fetchDistricts = async (cityId: string): Promise<RegionList> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.districts(cityId)}`);
};

export const fetchSubdistricts = async (districtId: string): Promise<RegionList<Subdistrict>> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.subdistricts(districtId)}`);
};
